import { roleDefault } from './state'

export function setRoles(state, roles) {
    state.roles = roles
}

export function setPermissions(state, permissions) {
    state.permissions = permissions;
}

export function setCategories(state, categories) {
  let categories_filte = categories.filter(category => category.name_parameter !== 'PERMISOS ESPECIALES');
  state.categories = categories_filte;
}

export function setCategoriesSpecials(state, categories) {
    let categories_filte = categories.filter(category => category.name_parameter === 'PERMISOS ESPECIALES');
    state.categories_specials = categories_filte;
  }

export function setCategorySelected(state, category_selected) {
  state.category.selected = category_selected;
}

export function setPermissionsSpecials(state, permissions_specials) {
    let permission_role= state.role.permissions;
    let permissions_specials_fil = [];
    if(state.categories_specials[0]['id']){
        permissions_specials_fil = permissions_specials.filter(pemision_speacial => pemision_speacial.category_role_id === state.categories_specials[0]['id']);
        permissions_specials_fil.map(function(pemision_speacial) {
            return pemision_speacial.selected = permission_role.find(p => p === pemision_speacial.id)?1:0;
         });
    }
    state.permissions_specials = permissions_specials_fil;
}

export function setModule(state, module) {
    state.module = module
}

export function setRoleDefault(state) {
    state.role = roleDefault();
    state.copyPermissions = [];
}
export function setRole(state, role) {
    state.role.id = role.id;
    state.role.name = role.role;
    state.role.costs = role.costs;
    state.role.stocks = role.stocks;
    state.role.permissions = role.getPermissions;
    state.copyPermissions = JSON.parse(JSON.stringify(role.getPermissions));
}
export function setActionForm(state, actionForm) {
    state.actionForm = actionForm;
}
export function setPromotionLoader(state, status) {
    state.promotionLoader = status
}

export function setPermissionsRole(state, permissions) {
    state.role.permissions = permissions
}

export function setUsers(state,users){
    state.users=users;

}

export function setPerPage(state, perPage) {
    state.params.page = 1;
    state.params.perPage = perPage;
  }

  export function setPage(state, page) {
    state.params.page = page;
  }

  export function setCosts(state, role) {
    state.role.costs = role;
  }

  export function setStocks(state, role) {
    state.role.stocks = role;
  }



// WEBPACK FOOTER //
// ./src/modules/roles/mutations.js